import { Vue, Component, Prop } from 'vue-property-decorator';

import LoadingSkeleton from '../loading-skeleton';

const style = require('./index.module.scss') as Dictionary;

@Component
export default class FormField extends Vue {
  // 表单项目的名称
  @Prop(String) readonly name!: string;

  // 附加的说明信息
  @Prop(String) readonly subName!: string;

  // 点击时是否背景色响应
  @Prop({
    type: Boolean,
    default: true,
  })
  readonly isActive!: boolean;

  // 是否显示右侧的箭头
  @Prop({
    type: Boolean,
    default: true,
  })
  readonly showArrow!: boolean;

  // 是否需要顶部分割线
  @Prop({
    type: Boolean,
    default: false,
  })
  readonly needDivider!: boolean;

  // 是否需要bottom分割线
  @Prop({
    type: Boolean,
    default: false,
  })
  readonly needBottomDivider!: boolean;

  // 名称显示骨架屏loading状态
  @Prop({
    type: Boolean,
    default: false,
  })
  readonly nameLoading!: boolean;

  private render() {
    return (
      <section
        class={[
          style.fieldContainer,
          this.isActive && style.isActive,
          this.showArrow && style.withArrow,
          this.needDivider && style.needDivider,
          this.needBottomDivider && style.needBottomDivider,
        ]}
        onClick={this.onClick.bind(this)}
      >
        {this.$slots.start}

        {this.nameLoading ? (
            <LoadingSkeleton width={64} height={26} radius={4} />
        ) : (
          <div class={style.nameWrap}>
            {this.name && <span class={style.name}>{this.name}</span>}
            {this.subName && <span class={style.subName}>{this.subName}</span>}
          </div>
        )}

        {this.$slots.middle}

        <div class={style.content}>{this.$slots.default}</div>

        {this.$slots.end}
      </section>
    );
  }

  private onClick() {
    if (this.showArrow) {
      this.$emit('click');
    }
  }
}
